const messages: { [key: string]: Record<string, string> } = {
    en: {
        modalTitleError: 'Error',
        modalNetworkSubtitle:
            'Network connection issue detected. Please verify you have a stable working internet connection and try again.',
        ok: 'Okay',
        continue: 'Continue',
        back: 'Back',
        landingPageTitle: 'Mobile Number',
        landingPageSubTitle: 'Please enter your mobile number to begin',
        landingPageLoginButton: 'Login',
        landingPageVerifyButton: 'Verify',
        landingPageVerifyTitle: 'Verification Code',
        landingPageVerifySubTitle: 'Please enter the code that was sent to your phone',
        landingPageResendCodeButton: 'Resend Code',
        landingPageVerifyFailure: 'Verification code is incorrect. Please try again.',
        dataRatesMayApply: 'Message and data rates may apply',
        driverInfoEntryTitle: 'Driver Information',
        driverInfoEntryInputLabelName: 'Name',
        driverInfoEntryInputLabelMobile: 'Mobile Number',
        driverInfoEntryInputPlaceholderName: 'Enter your name',
        driverInfoEntryInputLabelPickupOrDelivery: 'Pick-up or Delivery Number',
        driverInfoEntryInputPlaceholderPickupOrDelivery: 'Example: 34xxxxxx (8 digits)',
        driverInfoEntryInputLabelTrailerNumber: 'Trailer Number',
        driverInfoEntryInputLabelTrailerType: 'Trailer Type',
        driverInfoEntryInputLabelTrailerSize: 'Trailer Size',
        driverInfoEntryInputLabelOrderType: 'Order Type',
        driverInfoEntryInputLabelCarrierBroker: 'Carrier/Broker',
        driverInfoEntryInputLabelDestination: 'Destination',
        driverInfoEntryCarrierNotListed: 'Carrier not listed',
        driverInfoEntrySelectCarrierBroker: 'Select your Carrier/Broker',
        driverInfoEntryCarrierEntryDialogText: 'Please enter your carrier/broker name and SCAC',
        driverInfoEntryInputLabelDropOffTrailerNumber: 'Drop-off Trailer Number',
        driverInfoEntryInputLabelDropOffTrailerSize: 'Drop-off Trailer Size',
        driverInfoEntryInputLabelHasTrailer: 'Trailer Attached?',
        other: 'Other',
        submit: 'Submit',
        confirm: 'Confirm',
        termsAndConditionsSubTitle: 'I acknowledge and agree that:',
        termsAndConditionsOne: ' My trailer is in good condition.',
        termsAndConditionsTwo: ' My trailer is clean and free from debris and Odor.',
        termsAndConditionsThree: ' My trailer has a door to lock.',
        termsAndConditionsFour: ' I will slide back my tandems when before docking.',
        termsAndConditionsFive: ' I will ensure that my trailer is open prior to docking.',
        termsAndConditionsSix: ` I will properly restrain my trailer such that it remains in place during loading (e.g. ensuring the dock lock is engaged).`,
        termsAndConditionsSeven:
            ' I will not smoke nor engage in any unsafe, illegal or offensive behavior while on the premises.',
        termsAndConditionsEight: ' I will abide by all Niagara facility policies.',
        termsAndConditionsNine:
            ' Niagara is not responsible for costs, claims and liabilities associated with my failure to comply with the foregoing.',
        reportTitle: 'Precheck Summary',
        reportLabelName: 'Name',
        reportLabelPhoneNumber: 'Phone Number',
        reportLabelPickupNumber: 'Pickup Number',
        reportLabelTrailerNumber: 'Trailer Number',
        reportConfirmArrivalButton: 'Confirm Arrival',
        reportContactButton: 'Contact Niagara Team',
        reportFailedGeolocationText:
            'Please ensure that you are at the correct Niagara facility before clicking "Confirm Arrival".',
        reportSuccessGeolocationHeader: 'Request Submitted!',
        reportSuccessGeolocationText: 'We look forward to your arrival'
    },
    es: {
        modalTitleError: 'Error',
        modalNetworkSubtitle:
            'Se ha detectado un problema de conexión de red. Verifique que tenga una conexión a Internet estable y vuelva a intentarlo.',
        ok: 'Aceptar',
        continue: 'Continuar',
        back: 'Atrás',
        landingPageTitle: 'Número de móvil',
        landingPageSubTitle: 'Ingrese su número de móvil para comenzar',
        landingPageLoginButton: 'Iniciar sesión',
        landingPageVerifyButton: 'Verificar',
        landingPageVerifyTitle: 'Código de verificación',
        landingPageVerifySubTitle: 'Ingrese el código que se envió a su teléfono',
        landingPageResendCodeButton: 'Reenviar código',
        landingPageVerifyFailure: 'El código de verificación es incorrecto. Inténtalo de nuevo.',
        dataRatesMayApply: 'Pueden aplicarse tarifas de mensajes y datos',
        driverInfoEntryTitle: 'Información del conductor',
        driverInfoEntryInputLabelName: 'Nombre',
        driverInfoEntryInputLabelMobile: 'Número de móvil',
        driverInfoEntryInputPlaceholderName: 'Ingrese su nombre',
        driverInfoEntryInputLabelPickupOrDelivery: 'Número de recogida o entrega',
        driverInfoEntryInputPlaceholderPickupOrDelivery: 'Ejemplo: 34xxxxxx (8 dígitos)',
        driverInfoEntryInputLabelTrailerNumber: 'Número de remolque',
        driverInfoEntryInputLabelTrailerType: 'Tipo de remolque',
        driverInfoEntryInputLabelTrailerSize: 'Tamaño del remolque',
        driverInfoEntryInputLabelOrderType: 'Tipo de pedido',
        driverInfoEntryInputLabelCarrierBroker: 'Transportista/Corredor',
        driverInfoEntryInputLabelDestination: 'Destino',
        driverInfoEntryCarrierNotListed: 'Transportista no listado',
        driverInfoEntrySelectCarrierBroker: 'Seleccione su transportista/corredor',
        driverInfoEntryCarrierEntryDialogText:
            'Ingrese el nombre de su transportista/corredor y SCAC',
        driverInfoEntryInputLabelDropOffTrailerNumber: 'Número de remolque de entrega',
        driverInfoEntryInputLabelDropOffTrailerSize: 'Tamaño del remolque de entrega',
        driverInfoEntryInputLabelHasTrailer: '¿Remolque adjunto?',
        other: 'Otro',
        submit: 'Enviar',
        confirm: 'Confirmar',
        termsAndConditionsSubTitle: 'Reconozco y acepto que:',
        termsAndConditionsOne: ' Mi remolque está en buenas condiciones.',
        termsAndConditionsTwo: ' Mi remolque está limpio y libre de escombros y olores.',
        termsAndConditionsThree: ' Mi remolque tiene una puerta para cerrar.',
        termsAndConditionsFour: ' Deslizaré mis tándems antes de acoplarme.',
        termsAndConditionsFive: ' Me aseguraré de que mi remolque esté abierto antes de acoplarme.',
        termsAndConditionsSix: ` Aseguraré adecuadamente mi remolque para que permanezca en su lugar durante la carga (por ejemplo, asegurándome de que el bloqueo del muelle esté activado).`,
        termsAndConditionsSeven:
            ' No fumaré ni participaré en ningún comportamiento inseguro, ilegal u ofensivo mientras esté en las instalaciones.',
        termsAndConditionsEight:
            ' Cumpliré con todas las políticas de las instalaciones de Niagara.',
        termsAndConditionsNine:
            ' Niagara no es responsable de los costos, reclamos y responsabilidades asociados con mi incumplimiento de lo anterior.',
        reportTitle: 'Resumen de preverificación',
        reportLabelName: 'Nombre',
        reportLabelPhoneNumber: 'Número de teléfono',
        reportLabelPickupNumber: 'Número de recogida',
        reportLabelTrailerNumber: 'Número de remolque',
        reportConfirmArrivalButton: 'Confirmar llegada',
        reportContactButton: 'Contactar al equipo de Niagara',
        reportFailedGeolocationText:
            'Asegúrese de estar en la instalación correcta de Niagara antes de hacer clic en "Confirmar llegada".',
        reportSuccessGeolocationHeader: '¡Solicitud enviada!',
        reportSuccessGeolocationText: 'Esperamos su llegada'
    },
    ru: {
        modalTitleError: 'Ошибка',
        modalNetworkSubtitle:
            'Обнаружена проблема с сетевым подключением. Проверьте, что у вас есть стабильное рабочее подключение к Интернету и повторите попытку.',
        ok: 'Окей',
        continue: 'Продолжить',
        back: 'Назад',
        landingPageTitle: 'Мобильный номер',
        landingPageSubTitle: 'Введите свой мобильный номер, чтобы начать',
        landingPageLoginButton: 'Войти',
        landingPageVerifyButton: 'Подтвердить',
        landingPageVerifyTitle: 'Код подтверждения',
        landingPageVerifySubTitle: 'Введите код, который был отправлен на ваш телефон',
        landingPageResendCodeButton: 'Отправить код повторно',
        landingPageVerifyFailure: 'Неверный код подтверждения. Попробуйте еще раз.',
        dataRatesMayApply: 'Могут применяться тарифы на сообщения и данные',
        driverInfoEntryTitle: 'Информация о водителе',
        driverInfoEntryInputLabelName: 'Имя',
        driverInfoEntryInputLabelMobile: 'Мобильный номер',
        driverInfoEntryInputPlaceholderName: 'Введите свое имя',
        driverInfoEntryInputLabelPickupOrDelivery: 'Номер забора или доставки',
        driverInfoEntryInputPlaceholderPickupOrDelivery: 'Пример: 34xxxxxx (8 цифр)',
        driverInfoEntryInputLabelTrailerNumber: 'Номер прицепа',
        driverInfoEntryInputLabelTrailerType: 'Тип прицепа',
        driverInfoEntryInputLabelTrailerSize: 'Размер прицепа',
        driverInfoEntryInputLabelOrderType: 'Тип заказа',
        driverInfoEntryInputLabelCarrierBroker: 'Перевозчик/Брокер',
        driverInfoEntryInputLabelDestination: 'Место назначения',
        driverInfoEntryCarrierNotListed: 'Перевозчик не указан',
        driverInfoEntrySelectCarrierBroker: 'Выберите своего перевозчика/брокера',
        driverInfoEntryCarrierEntryDialogText: 'Введите имя своего перевозчика/брокера и SCAC',
        driverInfoEntryInputLabelDropOffTrailerNumber: 'Номер прицепа для сдачи',
        driverInfoEntryInputLabelDropOffTrailerSize: 'Размер прицепа для сдачи',
        driverInfoEntryInputLabelHasTrailer: 'Прицеп прикреплен?',
        other: 'Другое',
        submit: 'Отправить',
        confirm: 'Подтвердить',
        termsAndConditionsSubTitle: 'Я признаю и соглашаюсь с тем, что:',
        termsAndConditionsOne: ' Мой прицеп находится в хорошем состоянии.',
        termsAndConditionsTwo: ' Мой прицеп чистый и свободен от мусора и запахов.',
        termsAndConditionsThree: ' Мой прицеп имеет дверь для запирания.',
        termsAndConditionsFour: ' Я сдвину задние оси прицепа перед стыковкой.',
        termsAndConditionsFive: ' Я убедюсь, что мой прицеп открыт перед стыковкой.',
        termsAndConditionsSix: ` Я правильно закреплю свой прицеп так, чтобы он оставался на месте во время погрузки (например, убедившись, что замок дока включен).`,
        termsAndConditionsSeven:
            ' Я не буду курить и не буду заниматься небезопасным, незаконным или оскорбительным поведением на территории.',
        termsAndConditionsEight: ' Я буду соблюдать все правила объектов Niagara.',
        termsAndConditionsNine:
            ' Niagara не несет ответственности за расходы, претензии и обязательства, связанные с моим невыполнением вышеизложенного.',
        reportTitle: 'Сводка предварительной проверки',
        reportLabelName: 'Имя',
        reportLabelPhoneNumber: 'Номер телефона',
        reportLabelPickupNumber: 'Номер забора',
        reportLabelTrailerNumber: 'Номер прицепа',
        reportConfirmArrivalButton: 'Подтвердить прибытие',
        reportContactButton: 'Связаться с командой Niagara',
        reportFailedGeolocationText:
            'Пожалуйста, убедитесь, что вы находитесь на правильном объекте Niagara, прежде чем нажать "Подтвердить прибытие".',
        reportSuccessGeolocationHeader: 'Запрос отправлен!',
        reportSuccessGeolocationText: 'Мы ждем вашего прибытия'
    }

    // Add more languages as needed
};

export default messages;
